<template>
  <div class="sip_ui_border">
    <div class="sip_controls sip_ui_body">
      <ControlsSpeedometr :speed="speed" />
      <ControlsUpDown @clicked="onUpDown" />
    </div>
  </div>
</template>
<script>
import ControlsUpDown from './ControlsUpDown.vue'
import ControlsSpeedometr from './ControlsSpeedometr.vue'

export default {
  name: 'Controls',
  props: ['speed'],
  components: {
    ControlsUpDown,
    ControlsSpeedometr,
  },
  computed: {
    speedTitle() {
      if(this.speed > 0) {
        return 'вперед'
      } else if(this.speed < 0) {
        return 'назад'
      } else if(this.speed === 0) {
        return 'стоп'
      }
    }
  },
  methods: {
    onUpDown(val) {
      this.$emit('clicked', val)
    }
  },
}
</script>

<style lang="stylus">
.sip_controls
  display flex
  align-items flex-end
  justify-content space-around
</style>